import { isObject as t, pick as o, isString as f } from "./index125.js";
import r from "./index46.js";
function d(e) {
  if (e == null)
    throw new Error("mask property should be defined");
  return e instanceof RegExp ? r.MaskedRegExp : f(e) ? r.MaskedPattern : e === Date ? r.MaskedDate : e === Number ? r.MaskedNumber : Array.isArray(e) || e === Array ? r.MaskedDynamic : r.Masked && e.prototype instanceof r.Masked ? e : r.Masked && e instanceof r.Masked ? e.constructor : e instanceof Function ? r.MaskedFunction : (console.warn("Mask not found for mask", e), r.Masked);
}
function k(e) {
  if (!e)
    throw new Error("Options in not defined");
  if (r.Masked) {
    if (e.prototype instanceof r.Masked)
      return {
        mask: e
      };
    const {
      mask: n = void 0,
      ...a
    } = e instanceof r.Masked ? {
      mask: e
    } : t(e) && e.mask instanceof r.Masked ? e : {};
    if (n) {
      const s = n.mask;
      return {
        ...o(n, (c, i) => !i.startsWith("_")),
        mask: n.constructor,
        _mask: s,
        ...a
      };
    }
  }
  return t(e) ? {
    ...e
  } : {
    mask: e
  };
}
function u(e) {
  if (r.Masked && e instanceof r.Masked)
    return e;
  const n = k(e), a = d(n.mask);
  if (!a)
    throw new Error("Masked class is not found for provided mask " + n.mask + ", appropriate module needs to be imported manually before creating mask.");
  return n.mask === a && delete n.mask, n._mask && (n.mask = n._mask, delete n._mask), new a(n);
}
r.createMask = u;
export {
  u as default,
  d as maskedClass,
  k as normalizeOpts
};
